export const environment = {
  production: true,
  name: 'prod:bfl',
  serviceBaseUrls: {
    DOMAIN01: 'https://apis-marketplace.bajajfinserv.in/app01',
    DOMAIN02: 'https://www.bajajfinserv.in/marketplace',
    AEMURL: 'https://cms-api.bajajfinserv.in',
    RedirectDomain: 'https://www.bajajfinserv.in/marketplace',
    PaymentSuccessURLTWGI: 'https://www.bajajfinserv.in/marketplace/insurance/two-wheeler-insurance/bike-insurance-premium-calculator/paymentStatus',
    PaymentFailURLTWGI: 'https://www.bajajfinserv.in/marketplace/insurance/two-wheeler-insurance/bike-insurance-premium-calculator/paymentStatus',
    PaymentSuccessURLFWGI: 'https://www.bajajfinserv.in/marketplace/insurance/car-insurance/car-insurance-premium-calculator/paymentStatus',
    PaymentFailURLFWGI: 'https://www.bajajfinserv.in/marketplace/insurance/car-insurance/car-insurance-premium-calculator/paymentStatus',
    PaymentSuccessURLTXGI: 'https://www.bajajfinserv.in/marketplace/insurance/commercial-vehicle-insurance/taxi-car-insurance-calculator/paymentStatus',
    PaymentFailURLTXGI: 'https://www.bajajfinserv.in/marketplace/insurance/commercial-vehicle-insurance/taxi-car-insurance-calculator/paymentStatus',
    PaymentSuccessURLCVGI: 'https://www.bajajfinserv.in/marketplace/insurance/commercial-vehicle-insurance/commercial-vehicle-insurance-calculator/paymentStatus',
    PaymentFailURLCVGI: 'https://www.bajajfinserv.in/marketplace/insurance/commercial-vehicle-insurance/commercial-vehicle-insurance-calculator/paymentStatus',
    WebHookURL: 'https://apis-marketplace.bajajfinserv.in/app01/v2/insurance/payments/pgateways/updateHorizontalPaymentStatus',
    KYCSourceURLTWGI: 'https://www.bajajfinserv.in/marketplace/insurance/two-wheeler-insurance/bike-insurance-premium-calculator/ownerDetails',
    KYCSourceURLFWGI: 'https://www.bajajfinserv.in/marketplace/insurance/car-insurance/car-insurance-premium-calculator/ownerDetails',
    resumeUrlTWGI: 'https://www.bajajfinserv.in/marketplace/insurance/two-wheeler-insurance/bike-insurance-premium-calculator/customerLogin',
    resumeUrlFWGI: 'https://www.bajajfinserv.in/marketplace/insurance/car-insurance/car-insurance-premium-calculator/customerLogin',
    AEMBANNERSURL: 'https://cms-api.bajajfinserv.in/content/dam/insurance-marketplace/insurance-mall-dj/motorinsuranceitems/Transaction_SuccessFailure_Page.json'
  },
  endPoints: {},
  MERCHANTCODE: 'Qffnzj2s_test',
  paymentScript: 'https://pay-marketplace.bajajfinserv.in/pay/assets/paymentjs/checkout.js',
  hmr: true,
  bflenvironment: true,
  AnalyticsLink: '//assets.adobedtm.com/5fc97671c230/0ddce958995f/launch-37e18cce1354.min.js',
  paymentFirstCall: 'https://apis-marketplace.bajajfinserv.in/app01/',
  paymentSecondcall: 'https://pay-marketplace.bajajfinserv.in/',
  healthBannerURL: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow?utm_source=3IN1_APP_DI&utm_medium=homepage&utm_campaign=&utm_term=&utm_content=&isMobile=1&isDark=0',
  healthWebBannerURL: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow',
  isCleverTapEnabled: true,
  clevertapId: {
    web: ' W86-ZK8-K66Z',
    app: 'R9K-97K-8Z6Z'
}
};

